import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Globals } from 'src/app/shared/globals';
import { EducationService } from '../education.service';

@Component({
  selector: 'education-description',
  templateUrl: 'education-description.component.html',
  styleUrls: ['education-description.component.css']
})
export class EducationDescriptionComponent implements OnInit, OnDestroy {

  @Input() id!: string;
  descriptions!: any[];
  private subscription: Subscription = new Subscription();

  constructor(
    private educationService: EducationService,
    public globals: Globals
  ) {}

  ngOnInit() {
    console.log('kuvauksen id: ' + this.id)
    this.subscription = this.educationService.getEducationDescriptions(this.id).subscribe(
        descriptions => {
          this.descriptions = descriptions;
        }
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
